export const RESULT_COPY = {
  youResponded: 'You Responded',
  overallResults: 'Overall Results',
  closed: 'This poll has closed',
  notEnoughResults: 'There are not enough responses to display the results',
  error: 'Error finding poll',
};
